export const malgorzataOpara = {
    'mydrId': 'małgorzataopara',
    'firstName': 'Małgorzata',
    'lastName': 'Opara',
    'profession': 'Psychiatra',
    'avatar': 'malgorzata-opara.webp',
    'slug': 'psychiatra-malgorzata-opara',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'adult']
    ]
}